import { Formik } from "formik";
import React, { useRef, useState, FC, Dispatch, useEffect } from "react";
import { DatePicker } from "../../atoms/DatePicker";
import no_files_to_download from "../../../assets/images/no_files_to_download.svg";
import {
  BodyWrapper,
  HeaderText,
  HeaderWrapper,
  Wrapper,
  Divider,
  InputWrapper,
  InputContainer,
  InputField,
  InputLabel,
  ButtonsWrapper,
  SelectButtonWrapper,
  DownloadWrapper,
  OptionBtn,
  ImageWrapper,
  SelectStyled,
  DownOutlinedStyle,
  MainWrapper,
  Image,
  ButtonStyled,
  TableWrapper,
  TotalResultText,
  AnchorStyled,
} from "./elements";
import { Button } from "../../atoms/Button";
import moment from "moment";
import { Col } from "antd";
import { useIsMount, useMediaQuery } from "../../../hooks/common";
import { Table } from "../../organisms/Table";
import { sortSkills } from "../../../utils/helpers/transform";

type OptionProps = { label: string; value: string };

type Props = {
  formRef: any;
  options: { title: string; selected: boolean }[];
  optionCounter: number;
  toggleSelected: (title: string) => void;
  buttonSelector: (select: boolean) => void;
  onDownloadCsv: () => void;
  phases: OptionProps[];
  positions: OptionProps[];
  isLoading?: boolean;
  applicants?: Array<any>;
  setSelectedPhases: Dispatch<any>;
  selectedPhases: any;
  setSelectedPositions: Dispatch<any>;
  selectedPositions: any;
  disableDownload?: boolean;
};

const ApplicantsDatabase: FC<Props> = (props) => {
  const {
    formRef,
    options,
    optionCounter,
    toggleSelected,
    buttonSelector,
    onDownloadCsv,
    phases,
    positions,
    isLoading,
    applicants,
    setSelectedPhases,
    selectedPhases,
    setSelectedPositions,
    selectedPositions,
    disableDownload,
  } = props;
  const phasesRef = useRef<any>(null);
  const positionsRef = useRef<any>(null);

  const [openPhaseOptions, setOpenPhaseOptions] = useState(false);
  const [openPositionOptions, setOpenPositionOptions] = useState(false);

  const [tableColumn, setTableColumn] = useState<any>([]);
  const [showTable, setShowTable] = useState<boolean>(false);
  const setSkills = (skills: any) => {
    let uls: React.HTMLProps<HTMLLIElement>[] = [];
    for (let k of sortSkills(skills)) {
      uls = [
        ...uls,
        <li>
          <b>{k.skill}</b>: {k.value}
        </li>,
      ];
    }

    return uls;
  };
  const defaultColumn = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text: string) => (
        <div style={{ width: "200px" }}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "LinkedIn",
      dataIndex: "linkedinUrl",
      key: "linkedinUrl",
      render: (text: string) => (
        <div style={{ maxWidth: "300px", minWidth: "70px" }}>
          {text.length ? (
            <AnchorStyled href={text} target="_blank" rel="noreferrer">
              {text}
            </AnchorStyled>
          ) : (
            "N/A"
          )}
        </div>
      ),
    },
    {
      title: "Contact Number",
      dataIndex: "contactNumber",
      key: "contactNumber",
      render: (text: string) => (
        <div style={{ maxWidth: "180px", minWidth: "110px" }}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text: string) => (
        <div style={{ width: "200px" }}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Best time to contact",
      dataIndex: "timeToContact",
      key: "timeToContact",
      render: (text: string) => (
        <div style={{ width: "150px" }}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Resume",
      dataIndex: "resume",
      key: "resume",
      render: (text: string) => (
        <div style={{ width: "400px" }}>
          <AnchorStyled href={text} target="_blank" rel="noreferrer">
            {text}
          </AnchorStyled>
        </div>
      ),
    },
    {
      title: "Date Applied",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text: string) => (
        <div style={{ width: "160px" }}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Source of Application",
      dataIndex: "platform",
      key: "platform",
      render: (text: string) => (
        <div style={{ width: "150px" }}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Expected Salary",
      dataIndex: "salary",
      key: "salary",
      render: (text: string) => (
        <div style={{ width: "110px" }}>
          <span>₱ {text}</span>
        </div>
      ),
    },
    {
      title: "Knowledge & Skills",
      dataIndex: "skills",
      key: "skills",
      render: (skills: any) => (
        <div
          style={{
            minWidth: "400px",
            maxHeight: "150px",
            overflowY: "scroll",
          }}
        >
          <span></span>
          <ul>
            {setSkills(skills).map((skill, key) => (
              <span key={key}>{skill}</span>
            ))}
          </ul>
        </div>
      ),
    },
    {
      title: "Recruitment Status",
      dataIndex: "recruitmentStatus",
      key: "recruitmentStatus",
      render: (text: string) => (
        <div style={{ width: "150px" }}>
          <span>{text}</span>
        </div>
      ),
    },
  ];

  const commonProps = {
    mode: "multiple" as const,
    style: { width: "100%" },
    placeholder: "Select",
    maxTagCount: 1 as const,
  };
  const onChangeSelect = ({
    newValue,
    type,
    typeString,
    setState,
    selectedItems,
  }: any) => {
    const selectAll = () => {
      const allItems = type.map((item: OptionProps) => item.value);
      setState(["All", ...allItems]);
      return formRef.current?.setFieldValue(typeString, ["All", ...allItems]);
    };

    if (newValue.includes("All") || newValue[newValue.length - 1] === "All") {
      if (
        newValue.includes("All") &&
        newValue.length !== selectedItems.length &&
        selectedItems.length !== 0 &&
        newValue[newValue.length - 1] !== "All"
      ) {
        setState(newValue.slice(1, newValue.length));
        return formRef.current?.setFieldValue(
          typeString,
          newValue.slice(1, newValue.length)
        );
      }
      if (newValue[newValue.length - 1] === "All") {
        selectAll();
      }
      return selectAll();
    } else if (selectedItems.includes("All")) {
      setState([]);
      return formRef.current?.setFieldValue(typeString, []);
    } else if (newValue.length === type.length) {
      setState(["All", ...newValue]);
      return formRef.current?.setFieldValue(typeString, ["All", ...newValue]);
    }
    setState([...newValue]);
    setShowTable(false);
    formRef.current?.setFieldValue(typeString, [...newValue]);
  };

  const phaseProps = {
    ...commonProps,
    open: openPhaseOptions,
    onBlur: () => setOpenPhaseOptions(false),
    onFocus: () => setOpenPhaseOptions(true),
    value: selectedPhases,
    options: [{ label: "All", value: "All" }, ...phases],
    onChange: (newValue: string[]) => {
      onChangeSelect({
        newValue,
        type: phases,
        typeString: "phases",
        setState: setSelectedPhases,
        selectedItems: selectedPhases,
      });
    },
  };

  const positionProps = {
    ...commonProps,
    open: openPositionOptions,
    onBlur: () => setOpenPositionOptions(false),
    onFocus: () => setOpenPositionOptions(true),
    value: selectedPositions,
    options: [{ label: "All", value: "All" }, ...positions],
    onChange: (newValue: string[]) => {
      onChangeSelect({
        newValue,
        type: positions,
        typeString: "positions",
        setState: setSelectedPositions,
        selectedItems: selectedPositions,
      });
    },
  };

  const onClickSearch = () => {
    if (applicants?.length) {
      let updatedCol: any[] = [];
      for (let index = 0; index < defaultColumn.length; index++) {
        const col = defaultColumn[index];

        const optionExists = options.some((option) => {
          return (
            JSON.stringify({ title: col.title, selected: true }) ===
            JSON.stringify(option)
          );
        });

        if (optionExists) {
          updatedCol = [...updatedCol, col];
        }
      }
      setTableColumn([...updatedCol]);
    }
  };

  const [buttonTriggered1, setButtonTriggered1] = useState(false);
  const [buttonTriggered2, setButtonTriggered2] = useState(false);
  const isMount = useIsMount();
  useEffect(() => {
    if (!isMount) {
      buttonTriggered1 && setOpenPhaseOptions(!openPhaseOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonTriggered1]);
  useEffect(() => {
    if (!isMount) {
      buttonTriggered2 && setOpenPositionOptions(!openPositionOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonTriggered2]);
  useEffect(() => {
    openPhaseOptions ? phasesRef?.current.focus() : phasesRef?.current.blur();
  }, [openPhaseOptions]);

  useEffect(() => {
    openPositionOptions
      ? positionsRef?.current.focus()
      : positionsRef?.current.blur();
  }, [openPositionOptions]);

  const isXxl = useMediaQuery("(max-width: 1600px)");

  return (
    <MainWrapper>
      <Wrapper>
        <HeaderWrapper>
          <HeaderText>Applicants Database</HeaderText>
        </HeaderWrapper>
        <BodyWrapper>
          <InputWrapper>
            <Formik
              innerRef={formRef}
              onSubmit={() => {}}
              initialValues={{
                start_date: null,
                end_date: null,
                phases: [],
                positions: [],
              }}
              enableReinitialize={true}
              validateOnBlur={false}
              validateOnChange={false}
            >
              {({ values, handleSubmit, setFieldValue }) => (
                <form onSubmit={handleSubmit}>
                  <InputContainer>
                    <Col xxl={6} xl={12} lg={12} md={12} sm={12} xs={24}>
                      <InputField
                        style={
                          !isXxl
                            ? { paddingRight: "10%" }
                            : {
                                display: "flex",
                                alignContent: "space-between",
                                marginRight: 20,
                                marginBottom: "3%",
                              }
                        }
                      >
                        <InputLabel
                          style={
                            !isXxl
                              ? { width: "45%" }
                              : { width: "30%", textAlign: "end" }
                          }
                        >
                          Start Date
                        </InputLabel>
                        <DatePicker
                          name="start_date"
                          value={
                            values.start_date ? moment(values.start_date) : null
                          }
                          onChange={(date: any) =>
                            setFieldValue("start_date", date)
                          }
                          disabledDate={(current) => {
                            if (values.end_date) {
                              return (
                                new Date(
                                  moment(values.end_date)
                                    .format("MM/DD/YYYY")
                                    .valueOf()
                                ) <
                                new Date(current.format("MM/DD/YYYY").valueOf())
                              );
                            }
                            if (
                              new Date(
                                moment().format("MM/DD/YYYY").valueOf()
                              ) <
                              new Date(current.format("MM/DD/YYYY").valueOf())
                            ) {
                              return true;
                            }
                            if (
                              new Date(
                                moment()
                                  .subtract(1, "years")
                                  .format("MM/DD/YYYY")
                                  .valueOf()
                              ) >
                              new Date(current.format("MM/DD/YYYY").valueOf())
                            ) {
                              return true;
                            }
                            return false;
                          }}
                        />
                      </InputField>
                    </Col>
                    <Col xxl={6} xl={12} lg={12} md={12} sm={12} xs={24}>
                      <InputField
                        style={
                          !isXxl
                            ? { paddingRight: "10%" }
                            : {
                                display: "flex",
                                alignContent: "space-between",
                                marginRight: 20,
                                marginBottom: "3%",
                              }
                        }
                      >
                        <InputLabel
                          style={
                            !isXxl
                              ? { width: "45%" }
                              : { width: "30%", textAlign: "end" }
                          }
                        >
                          End Date
                        </InputLabel>
                        <DatePicker
                          name="end_date"
                          value={
                            values.end_date ? moment(values.end_date) : null
                          }
                          disabled={!values.start_date}
                          disabledDate={(current) => {
                            if (
                              new Date(
                                moment(values.start_date)
                                  .format("MM/DD/YYYY")
                                  .valueOf()
                              ) >
                              new Date(current.format("MM/DD/YYYY").valueOf())
                            ) {
                              return true;
                            }
                            if (
                              new Date(
                                moment().format("MM/DD/YYYY").valueOf()
                              ) <
                              new Date(current.format("MM/DD/YYYY").valueOf())
                            ) {
                              return true;
                            }
                            return false;
                          }}
                          onChange={(date: any) =>
                            setFieldValue("end_date", date)
                          }
                        />
                      </InputField>
                    </Col>
                    <Col xxl={6} xl={12} lg={12} md={12} sm={12} xs={24}>
                      <InputField
                        style={
                          !isXxl
                            ? { paddingRight: "5%" }
                            : {
                                display: "flex",
                                alignContent: "space-between",
                                marginRight: 20,
                                marginBottom: "3%",
                              }
                        }
                      >
                        <InputLabel
                          style={
                            !isXxl
                              ? { width: "25%" }
                              : { width: "30%", textAlign: "end" }
                          }
                        >
                          Phase
                        </InputLabel>
                        <div style={{ width: "100%" }}>
                          <SelectStyled
                            {...(phaseProps as any)}
                            ref={phasesRef}
                            dropdownStyle={{ minWidth: "15%", maxWidth: "16%" }}
                          />
                          <DownOutlinedStyle
                            onClick={() => {
                              return setButtonTriggered1(!buttonTriggered1);
                            }}
                          />
                        </div>
                      </InputField>
                    </Col>
                    <Col xxl={6} xl={12} lg={12} md={12} sm={12} xs={24}>
                      <InputField
                        style={
                          !isXxl
                            ? { paddingLeft: "5%" }
                            : {
                                display: "flex",
                                alignContent: "space-between",
                                marginRight: 20,
                                marginBottom: "3%",
                              }
                        }
                      >
                        <InputLabel
                          style={
                            !isXxl
                              ? { width: "25%" }
                              : { width: "30%", textAlign: "end" }
                          }
                        >
                          Position
                        </InputLabel>
                        <div style={{ width: "100%" }}>
                          <SelectStyled
                            {...(positionProps as any)}
                            ref={positionsRef}
                            dropdownStyle={{ minWidth: "15%", maxWidth: "16%" }}
                          />
                          <DownOutlinedStyle
                            onClick={() => {
                              return setButtonTriggered2(!buttonTriggered2);
                            }}
                          />
                        </div>
                      </InputField>
                    </Col>
                  </InputContainer>
                </form>
              )}
            </Formik>
          </InputWrapper>
          <Divider />
          <ButtonsWrapper>
            <SelectButtonWrapper>
              <Button
                type={"default"}
                onClick={() => {
                  buttonSelector(true);
                  onClickSearch();
                }}
              >
                Select All
              </Button>
              <Button
                type={"default"}
                onClick={() => {
                  buttonSelector(false);
                  onClickSearch();
                }}
              >
                Deselect All
              </Button>
            </SelectButtonWrapper>
            {options.map((option, key) => (
              <OptionBtn
                key={key}
                isSelected={option.selected}
                onClick={() => {
                  toggleSelected(option.title);
                  onClickSearch();
                }}
              >
                {option.title}
              </OptionBtn>
            ))}
          </ButtonsWrapper>
          <Divider />
          <DownloadWrapper>
            <ButtonStyled
              disabled={
                (applicants && applicants.length === 0) ||
                optionCounter <= 0 ||
                disableDownload
              }
              loading={isLoading}
              type={"primary"}
              onClick={() => {
                onClickSearch();
                setShowTable(true);
              }}
            >
              Search
            </ButtonStyled>
            <Button
              disabled={
                (applicants && applicants.length === 0) ||
                optionCounter <= 0 ||
                disableDownload
              }
              loading={isLoading}
              type={"primary"}
              onClick={onDownloadCsv}
            >
              Download CSV
            </Button>
          </DownloadWrapper>
          {applicants && applicants.length && optionCounter > 0 && showTable ? (
            <TableWrapper>
              <TotalResultText>
                ({applicants.length} Result{applicants.length > 1 && "s"})
              </TotalResultText>
              <Table
                columns={tableColumn}
                tableData={[
                  ...applicants.map((applicant, key) => {
                    return {
                      key: key,
                      ...applicant,
                    };
                  }),
                ]}
                hidePagination={true}
                scroll={{ y: window.screen.height / 3, x: "auto" }}
              />
            </TableWrapper>
          ) : null}
          {((applicants && applicants.length === 0) ||
            optionCounter <= 0 ||
            disableDownload) && (
            <ImageWrapper>
              <Image src={no_files_to_download} alt="No files to download" />
            </ImageWrapper>
          )}
        </BodyWrapper>
      </Wrapper>
    </MainWrapper>
  );
};

export default ApplicantsDatabase;
